import { Clickable } from 'src/shared/design-system/Utilities';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

const getSharedButtonStyles = ({ selected = false }: { selected?: boolean }) =>
  match({ selected })
    .with(
      { selected: true },
      () => css`
        background: ${Colors.MINT_50};
        border: 1px solid ${Colors.MINT_400};
      `
    )
    .with(
      { selected: false },
      () => css`
        background: ${Colors.WHITE};
        border: 1px solid ${Colors.GRAY_LITE_10};
      `
    )
    .exhaustive();

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-top: ${Border.Base} ${Colors.GRAY_LITE_10};
  font-family: ${Font.Family.SANS};
  padding: ${Spacing.SINGLE} 0;

  ${Mixins.Media.minWidthMedium(`
    &:nth-child(1), &:nth-child(2), &:nth-child(3) {
      border-top: none;
    }
  `)}

  ${Mixins.Media.minWidthSmall(`
    &:nth-child(1), &:nth-child(2) {
      border-top: none;
    }
  `)}

  ${Mixins.Media.maxWidthSmall(`
    &:nth-child(1) {
      border-top: none;
    }
    padding: ${Spacing.SINGLE_HALF};
  `)}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  color: ${Colors.GRAY_DARK_30};
  font-size: ${Font.Size.S};
  font-weight: ${Font.Weight.SEMI_BOLD};
  margin-bottom: ${Spacing.HALF};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacing.HALF};
  flex-wrap: wrap;
`;

export const Button = styled(Clickable)<{ selected?: boolean; size?: number }>`
  align-items: center;
  border-radius: ${Border.Radius.M};
  cursor: pointer;
  display: flex;
  justify-content: center;
  font-size: ${Font.Size.S};
  flex-shrink: 0;
  gap: ${Spacing.HALF};
  padding: ${Spacing.HALF} ${Spacing.THREE_QUARTERS};
  ${getSharedButtonStyles}
`;

export const ButtonDishType = styled(Button)`
  & svg {
    transform: translateY(-0.075em);
  }
`;

export const ButtonText = VerticallyCenteredText;

export const RoundButton = styled(Clickable)<{ selected?: boolean; size?: number }>`
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  line-height: ${Font.LineHeight.XXS};
  flex-shrink: 0;

  ${({ size = 72 }) => Mixins.Shape.square(`${size}px`)}
  ${getSharedButtonStyles}
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
